import React, { useContext, useEffect, useState } from 'react';
import LinkMediaVideoHeader from './LinkMediaVideoHeader';
import GallerySection from './GallerySection';
import VideoController from './VideoController';
import PlayAllButton from './PlayAllButton';
import TitleSubtitleUpdate from './TitleSubtitleUpdate';
import { useParams } from 'react-router-dom';
import { Context } from "../contexts/AppContext";
import { deleteData, getData } from '../../lib/utils';
import AudioPlayer from './AudioPlayer';
import Icons from "../Icons/index";
import ImageController from './ImageController';
import PhotoButton from './PhotoButton';
import PhotoOnly from '../Gallery/PhotoOnly';

const isGalleryId = (input) => /^[0-9a-fA-F]{24}$/.test(input);

const LinkMedia = () => {
  const { galleryId: identifier } = useParams();
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const [modalOpen, setModalOpen] = useState(appState.modalData);
  const [temp, setTemp] = useState("ChapterListModal");
  const PropertyObj = Icons[temp];

  // 🔹 iOS detection
  const [isIOS, setIsIOS] = useState(false);
  const [isStarted, setIsStarted] = useState(false);
 

  console.log("LINKKKKKKKKKKKKKKKKKKKKKKKKKKKKKK Media")

  const modalData = appState?.modalData || {};
 
  
  const [isPasswordLocked, setPasswordLocked] = useState(true);

useEffect(() => {
  setPasswordLocked(
    appState?.currentGalleryData?.passwordEnabled || false
  );
}, [appState?.currentGalleryData?.passwordEnabled]);
  //appState?.currentGalleryData?.passwordEnabled &&
  //  !appState?.passwordVerified
  //alert(appState?.currentGalleryData?.passwordEnabled)
  console.log("IIIIIIIIIIIIIIIII ",appState?.currentGalleryData?.passwordEnabled)

  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/.test(ua)) {
      setIsIOS(true);
    }
  }, []);

  useEffect(() => {
    setModalOpen(appState.modalData);
  }, [appState.modalData]);

 

 useEffect(() => {
  switch (modalOpen?.type) {
    case "ChapterListModal":
      setTemp("ChapterListModal");
      break;

    case "DownloadVideoModal":
      setTemp("DownloadVideoModal");
      break;

    case "WatchOnTvModal":
      setTemp("WatchOnTvModal");
      break;

    case "PhotoThumbnailModal":
      setTemp("PhotoThumbnailModal");
      break;

    case "QrCodeModal":
      setTemp("QrCodeModal");
      break;

    case "PasswordModal":
      setTemp("PasswordModal");
      break;

    default:
      break;
  }
}, [modalOpen?.type]);

  // Fetch gallery data
  useEffect(() => {
    const fetchData = async () => {
      try {
        let data;
        if (isGalleryId(identifier)) {
          data = await getData(`galleries/gallery/${identifier}`);
        } else {
          data = await getData(`galleries/gallery/customurl/${identifier}`);
        }
        

        localStorage.setItem('title', data?.gallery?.title);
        if (data) {
          console.log("DDDDDDDDDDDDDDDDDDDD ",data)
          setAppState((prevState) => ({
            ...prevState,
            folder: data.folder,
            gallery: data.gallery,
            currentGalleryData: data.gallery,
            videos: data.videos,
            photos: data.photos,
            backgroundMedia: data?.gallery?.backgroundMedia,
            videoArr: data.videos || [],
            currentGalleryVideoTitle: data.gallery?.title || "",
            currentGalleryVideoSubTitle: data.gallery?.subtitle || "",

            currentTitleColor: data.gallery?.titleColor || "",
            currentSubTitleColor: data.gallery?.subTitleColor || "",
            currentFontFamilyVideoTitle: data.gallery?.fheading || "",
            currentFontFamilyVideoSubTitle: data.gallery?.fbody || "",
            currentTitleFontSize: data.gallery?.titleFontSize || "",
            currentSubTitleFontSize: data.gallery?.subTitleFontSize || "",
            currentFontLogo: data.gallery?.flogo || "",
            currentLogoColor: data.gallery?.logoColor || "",
            
          }));

          const response = await getData(
            `admin/admin-details-client/${data.folder.adminId}`
          );

          if (response) {
            if (window.injectBrandingAssets) {
              window.injectBrandingAssets(
                response?.admin?.id,
                data.gallery._id,
                process.env.REACT_APP_VIDEO_DEST_BASE_PATH,
                process.env.REACT_APP_API_PATH,
                response?.admin?.companyFaviconUrl,
                response?.admin?.companyLogoUrl,
                data?.gallery?.backgroundMedia?.imgUrl,
                data?.gallery?.title
              );
            }
            setAppState((prevState) => ({
              ...prevState,
              adminDetails: response.admin,
            }));
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [identifier, setAppState]);


useEffect(() => {
  if (
    appState?.currentGalleryData?.passwordEnabled &&
    !appState?.passwordVerified
  ) {
    setAppState((prev) => ({
      ...prev,
      modalData: {
        ...prev.modalData,
        type: "PasswordModal",
        isOpen: true,
      },
    }));
  }
}, [
  appState?.currentGalleryData?.passwordEnabled,
  appState?.passwordVerified,
]);

useEffect(() => {
  const handleMessage = (event) => {
    if (
      typeof event.data === "object" &&
      event.data !== null
    ) {
      setAppState((prev) => ({
        ...prev,
        ...event.data,
      }));
    }
  };

  window.addEventListener(
    "message",
    handleMessage
  );

  return () =>
    window.removeEventListener(
      "message",
      handleMessage
    );
}, []);

  const templateId = Number(appState?.currentGalleryData?.templateid);

  const passwordMatched = () => {
    setPasswordLocked(false)
  }

  return (
  <>
    {isPasswordLocked ? (
      <div className="fixed inset-0 z-[9999] bg-black">
          <PropertyObj passwordMatched={passwordMatched} />
      </div>
    ) : (
      <>
        {isIOS && !isStarted ? (
          <div className="flex flex-col justify-center items-center min-h-screen">
            <button
              onClick={() => {
                setIsStarted(true);
                window.dispatchEvent(
                  new Event("iphonePlayAllowed")
                );
              }}
              className="px-6 py-3 bg-gray-700 text-white rounded-lg"
            >
              Start Preview
            </button>
          </div>
        ) : (
                <>
                  
                  <div className="fixed inset-0 -z-10 w-full h-full">
                  
              {appState.currentGalleryData?.backgroundMedia?.imgUrl && (
                <ImageController />
              )}

              {appState.currentGalleryData?.backgroundMedia?.videoUrl && (
                <VideoController />
              )}
                  </div>
                  

            <div className="min-h-screen flex flex-col h-screen relative z-10 overflow-auto md:overflow-hidden">
                    {/* Existing Header/Main/Footer */}
                       <header className="text-white px-4">
              {templateId === 0 && appState?.currentGalleryData && (
                <div className='w-full'>
                  <LinkMediaVideoHeader appState={appState} />
                </div>
              )}
              {templateId === 1 && appState?.currentGalleryData && (
                <div style={{ width: 'calc(100% - 430px)' }}>
                  <LinkMediaVideoHeader appState={appState} />
                </div>
              )}
              <TitleSubtitleUpdate />
            </header>

              <main className="flex w-full justify-between px-10">
              
              {appState?.videos?.length > 1 &&
                appState?.currentGalleryData?.setting?.playall && <PlayAllButton />
                }
                
                 

              {appState?.currentGalleryData?.backgroundMedia?.musicUrl && (
                <AudioPlayer
                  id="musicplayer"
                  musicPath={`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${appState?.currentGalleryData?.backgroundMedia?.musicUrl}`}
                />
              )}
            </main>

                    <footer className="text-white mt-auto   ">
                      
                      <GallerySection />
                      
                    </footer>
                  </div>
          </>
        )}
      </>
    )}

    {!isPasswordLocked && modalData?.isOpen && (
      <div
        id="MODAL_POPUP"
        className="relative z-20"
      >
        <PropertyObj />
      </div>
    )}
  </>
);
};

export default LinkMedia;
